import type { BrandColor, LoginInput, LoginResult, RegisterCodeResult, RegisterInput } from "@cafe/shared";
import type { RemoteImageData } from "@cafe/ui";
import { api, http } from "@/shared/api/client";
import { useAuth } from "./store";

export type Me = {
  id: string;
  name: string;
  email: string | null;
  phone: string | null;
  hasPin: boolean;
  company: {
    id: string; name: string; timezone: string; baseCurrency: string; siteSlug: string | null; onboardingCompleted: boolean;
    /** Свой бренд (addon.white_label) или null — Coca */
    brand: { name: string | null; color: BrandColor | null; logo: RemoteImageData | null } | null;
    /** Сброс отчётов: отчёты считаются с этой даты; null — с начала работы */
    reportsFrom: string | null;
  };
  roles: { code: string; name: string; scope: string; branchId: string | null }[];
  /** timezone и dayCutoff — «сегодня» филиала (бизнес-день, BR-013) */
  branches: { id: string; name: string; slug: string; timezone: string; dayCutoff: string; currency: string; isActive: boolean; formats: string[] }[];
  defaultBranchId: string | null;
};

export const authApi = {
  login: (body: LoginInput) => http.post<LoginResult>("/auth/login", body, { auth: false }),
  /** 2FA: второй шаг входа (код из приложения или резервный) */
  verifyTwoFactor: (challengeToken: string, code: string) => http.post<Extract<LoginResult, { status: "ok" }>>("/auth/2fa/verify", { challengeToken, code }, { auth: false }),
  /** Регистрация, шаг 1: код подтверждения на email */
  registerCode: (email: string) => http.post<RegisterCodeResult>("/auth/register/code", { email }, { auth: false }),
  /** Шаг 2: данные + код из письма */
  register: (body: RegisterInput) => http.post<Extract<LoginResult, { status: "ok" }>>("/auth/register", body, { auth: false }),
  me: () => api<Me>("GET", "/me", { branch: false }),
  async logout() {
    await http.post("/auth/logout").catch(() => undefined);
    useAuth.getState().clear();
  },
};
